<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">Many thanks to the following people, without whom <i>Crystal Clear</i> would still be a germ of an idea: former Barnes &amp; Noble community relations whiz Judy Martin, who said, “So maybe your next heroine goes to an ashram?”; Ruth Harris, who came up with the book’s title; my agent, Ellen Levine, who was supportive beyond the call of duty; and my editor, Ann La Farge, who worked her usual magic on my words.</p>
<p>Special thanks to my husband, Michael Forester, for allowing his aura to be cleansed, his energies to be palpated, and all the rest.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5ce363a4